import React, { useCallback, useRef, useMemo } from 'react';
import { useTranslation } from '../../../../localization/useTranslation';
import Tl from '../../../../localization/LocalizationKeys';
import _ from 'lodash';
import ModelType from '../../../Model/ModelType';
import ContentTable from '../utils/ContentTable';
import { dtdlNameError } from '../utils/model';

const columns = [
  {
    label: Tl.model.name,
    path: 'name',
    searchItem: true,
    isSortable: true
  },
  {
    label: Tl.model.displayName,
    path: 'displayName',
    searchItem: true,
    isSortable: true
  },
  {
    label: Tl.model.schema,
    path: 'schema',
    render: val => val.displayName
  },
  {
    label: Tl.model.description,
    path: 'description',
    searchItem: true
  },
  {
    label: Tl.model.comment,
    path: 'comment',
    searchItem: true
  }
];


export const ComponentTab = ({ components, onComponentsUpdate, currentNames, componentModels, modelDraft }) => {
  const T = useTranslation();
  const currentlyEditingItem = useRef({});


  const nameHasError = useCallback((name) => {
    return dtdlNameError(name, _.reject(currentNames, n => currentlyEditingItem.current.name === n));
  }, [currentNames]);

  const componentModel = useMemo(() => {
    return [
      {
        type: ModelType.TEXT,
        label: T.model.name,
        path: 'name',
        isRequired: true,
        isReadOnly: modelDraft === false,
        hasError: nameHasError
      },
      {
        type: ModelType.OPTIONSV2,
        label: T.model.schema,
        path: 'schema',
        isRequired: true,
        disabled: modelDraft === false,
        options: _.map(componentModels, value => ({ value, text: value.displayName, description: value.id })),
        hasError: _.isEmpty
      },
      {
        type: ModelType.TEXT,
        label: T.model.displayName,
        path: 'displayName',
        isRequired: true,
        isReadOnly: modelDraft === false,
        hasError: _.isEmpty
      },
      {
        type: ModelType.TEXT,
        label: T.model.description,
        path: 'description',
        isReadOnly: modelDraft === false,
        isRequired: false
      },
      {
        type: ModelType.TEXT,
        label: T.model.comment,
        isReadOnly: modelDraft === false,
        path: 'comment'
      }
    ];
  }, [T.model.comment, T.model.description, T.model.displayName, T.model.name, T.model.schema, componentModels, modelDraft, nameHasError]);


  const onSave = useCallback((content) => {
    onComponentsUpdate(content);
  }, [onComponentsUpdate]);
  return (
    <>
      <ContentTable
        title={T.model.tab.components}
        columns={columns}
        data={components}
        dialogModel={componentModel}
        updatedContent={() => {}}
        onSave={onSave}
        currentlyEditing={item => {
          currentlyEditingItem.current = item;
        }}
        modelDraft={modelDraft}
      />
    </>
  );
};
